/**
 * hauer-product.js
 * Página de produto "Versão 2 · Encaixe primeiro" (sections/hauer-product-main.liquid), aprovada em 24/09/2026.
 *  - Painel "Will it fit your bike?": Make / Model / Year montados do menu da garagem (JSON do layout,
 *    snippets/hauer-garage-data), modelos iguais de gerações diferentes viram um só (os anos se somam e o
 *    handle da coleção sai do ano escolhido); a moto da peça vem pré-selecionada. Respostas: serve (verde),
 *    ano errado (âmbar + card do kit certo, dos kits irmãos que o Liquid mandou em D.sibs), outra moto
 *    (âmbar + "Parts for my {bike}" via HauerGarage.bikeUrl), moto fora da lista (WhatsApp + "I've checked,
 *    it fits", que libera a compra e grava a confirmação em properties[Bike]).
 *  - Opções: bolinhas de cor com SALE (compare_at_price), pílulas de texto para tamanho; a foto troca para a
 *    da variante ("Your pick"); preço, "Save", botão e barra fixa acompanham.
 *  - Botão principal diz o próximo passo: escolher a opção, "Add anyway" (moto que não confere), "Add to cart · $".
 *  - Tabela de encaixe marca a linha do ano do cliente; Compare marca a coluna desta série e completa preço/link
 *    das outras séries (D.peers); "Riders say" com 3 avaliações com foto do Judge.me (window.HauerReviews).
 * Mantido do grupo A (24/09/2026): A-02 faixa aberta (D.open), A-03 HauerGarage.bikeUrl, A-04 promessa com data
 * (HauerGarage.shipDate, D.madeSignal, selo data-hauer-trust-ship-*), A-08 moto fora do menu (source "product"),
 * A-09 "hauer:garage:open" abre o painel, A-12 tabela, A-13 properties[Bike] + HauerGarage.track, A-14 CTA com
 * aria-disabled, Shop Pay com inert até variante + moto, tabindex rotativo nas opções, A-15 apelidos de opção,
 * A-17 vídeos no palco da galeria. O envio continua no <product-form> do Enterprise (gaveta nativa).
 * 24/09/2026 (QA): "Add anyway" vale só para o envio (painel e Shop Pay seguem o ano errado), moto fora da lista
 * exige a moto escrita, "Parts for my {model}" abre a coleção da moto sem filtro de tipo, preços sem ".00",
 * "Riders say" prefere avaliações do mesmo tipo de peça e cita no máximo 60 caracteres.
 */
(function () {
  'use strict';

  // Tons das cores do catálogo (maquete aprovada; nomes mais longos primeiro para "matte racing red" vencer "red").
  var COLORS = [
    ['matte racing red', '#c2372d'], ['racing red', '#e3261c'], ['matte red', '#b0262b'], ['red', '#d0131b'],
    ['matte light blue', '#6fa3cc'], ['light blue', '#58a9e8'], ['dark blue', '#1c2f6e'], ['matte blue', '#2f5ba6'], ['blue', '#1a5fd0'],
    ['light gold', '#dcc27d'], ['dark gold', '#97712a'], ['matte gold', '#b8963e'], ['gold', '#d2a01b'],
    ['dark green', '#1d5a34'], ['matte green', '#327d47'], ['green', '#1f9d3a'],
    ['dark purple', '#432470'], ['purple', '#6f3fb5'], ['pink', '#e3368a'], ['orange', '#f26b0f'], ['yellow', '#f3cf1a'],
    ['matte white', '#f1f0ec'], ['white', '#f7f7f5'], ['matte black', '#2a2a2a'], ['black', '#111111'],
    ['titanium', '#8a8d91'], ['carbon', '#333333'], ['silver', '#c3c6ca'], ['grey', '#8a8a8a'], ['gray', '#8a8a8a'], ['bronze', '#8c6239']
  ];
  function colorFor(name) {
    var n = String(name || '').toLowerCase();
    for (var i = 0; i < COLORS.length; i++) if (n.indexOf(COLORS[i][0]) > -1) return COLORS[i][1];
    return null;
  }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function fill(tpl, map) { return String(tpl || '').replace(/\{(\w+)\}/g, function (_, k) { return map[k] != null ? map[k] : ''; }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var out = String(fmt || '${{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, withCommas);
    // Valor redondo sem ".00", como na maquete ($229, $159); centavos reais ficam ($99.99). 24/09/2026
    return out.replace(/[.,]00(?=[^0-9]*$)/, '');
  }
  function track(event, data) {
    var G = window.HauerGarage;
    if (G && typeof G.track === 'function') { try { G.track(event, data); } catch (e) { /* noop */ } return; }
    var payload = Object.assign({ event: 'hauer_' + event }, data || {});
    try { document.dispatchEvent(new CustomEvent('hauer:track', { detail: payload })); } catch (e) { /* noop */ }
    try { window.dataLayer = window.dataLayer || []; if (typeof window.dataLayer.push === 'function') window.dataLayer.push(payload); } catch (e) { /* noop */ }
  }
  function cutoffLabel(h) { var hh = +h || 14; return (hh % 12 || 12) + (hh < 12 ? ' am' : ' pm'); }
  function focusNoScroll(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  var THIS_YEAR = new Date().getFullYear();
  var ICON = {
    ok: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>',
    no: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M12 5.5v8.5"/><circle cx="12" cy="18.6" r="1.1" fill="currentColor"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M12 3 4 6v6c0 4.5 3.4 8 8 9 4.6-1 8-4.5 8-9V6z"/><path d="m8.5 12 2.5 2.5 4.5-5"/></svg>',
    q: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .8-1 1.5M12 16.5v.5"/></svg>',
    bike: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="5.5" cy="16.5" r="3.5"/><circle cx="18.5" cy="16.5" r="3.5"/><path d="M5.5 16.5 9 9h5l4.5 7.5M12 9l-1.5-3H8M14 9h3l1-2"/></svg>'
  };

  function init(root) {
    if (root.dataset.hauerPdpReady) return;
    root.dataset.hauerPdpReady = '1';
    var host = root.parentElement || document;
    var D, T;
    try { D = JSON.parse(host.querySelector('[data-hauer-pdp-data]').textContent); T = JSON.parse(host.querySelector('[data-hauer-pdp-t]').textContent); } catch (e) { return; }
    var G = window.HauerGarage;
    var $ = function (s, el) { return (el || root).querySelector(s); };
    var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };

    var fitBox = $('[data-hp-fit]');
    if (!fitBox) return;
    var fitForm = $('[data-hp-fit-form]'), fitRes = $('[data-hp-fit-result]');
    var selMake = $('[data-hp-sel="make"]'), selModel = $('[data-hp-sel="model"]'), selYear = $('[data-hp-sel="year"]');
    var fitErr = $('[data-hp-fit-err]'), fitCancel = $('[data-hp-fit-cancel]'), fitAsk = $('[data-hp-fit-ask]');
    var fitTitle = $('[data-hp-fit-title]'), fitSub = $('[data-hp-fit-sub]');
    var nlBox = $('[data-hp-nl]'), nlBike = $('[data-hp-nl-bike]'), nlBtn = $('[data-hp-override]'), nlErr = $('[data-hp-nl-err]');
    var optBoxes = $$('[data-hp-opt]');
    var addBtn = $('[data-hauer-add]'), statusEl = $('[data-hauer-status]'), ctaNote = $('[data-hp-ctanote]');
    var form = $('.js-product-form-main');
    var input = $('[data-hauer-variant-input]');
    var bikeProp = $('[data-hauer-bike-prop]');
    var express = $('[data-hauer-express]'), expressNote = $('[data-hauer-express-note]');
    var nowEl = $('[data-hp-now]'), wasEl = $('[data-hp-was]'), saveEl = $('[data-hp-save]');
    var qtyIn = $('[data-hp-qtyin]');
    var promise = $('[data-hauer-promise]'), pTitle = $('[data-hauer-promise-title]'), pText = $('[data-hauer-promise-text]');
    var mainImg = $('[data-hp-main]'), thumbs = $('[data-hp-thumbs]'), galCnt = $('[data-hp-count]'), galCap = $('[data-hp-cap]');
    var galVids = $$('.hp-stage__vid');
    var sticky = $('[data-hp-sticky]'), stBtn = $('[data-hp-stbtn]'), stSt = $('[data-hp-stst]'), stP = $('[data-hp-stp]');
    var instInput = host.querySelector('#hauer-installments-form [name="id"]');

    var tags = D.tags || [];
    var tagsN = tags.map(norm);
    // 02/11/2026: tokens do encaixe no formato do card (tags + "ttl:<título>"), conferidos por HauerGarage.bikeMatch:
    // a mesma regra dos cards, do carrinho e da grade (apelidos do menu; marca e modelo também pelo título).
    var fitTokens = tags.concat(['ttl:' + String(D.title || '')]);
    function bikeOk(g) {
      if (G && typeof G.bikeMatch === 'function') return G.bikeMatch(fitTokens, g);
      return tagsN.indexOf(norm(g.brand)) > -1 && tagsN.indexOf(norm(g.model)) > -1;
    }
    // 03/11/2026: 1000, 1098, 1199, 1250 são modelos (KTM 1290, Panigale 1199), não anos
    var years = tags.filter(function (t) { return /^(19[5-9]\d|20\d\d)$/.test(t); });
    var selected = (D.options || []).map(function () { return null; });
    var variant = null;
    if (D.selected) {
      D.variants.forEach(function (v) { if (v.id === D.selected) variant = v; });
      if (variant && !D.onlyDefault && D.preselected) selected = variant.options.slice();
    }
    if (D.onlyDefault) variant = D.variants[0];
    // product-form.js religa o <input name=id> ao iniciar; sem variante escolhida o formulário não leva id (A-14).
    if (input) input.disabled = !variant;
    var state = { garage: null, fit: 'none', editing: false, override: null, qty: 1, gal: [], idx: 0, busy: false };

    /* ================= Garagem: marcas e modelos do menu ================= */
    function garageData() {
      var el = host.querySelector('[data-hauer-garage-data]') || document.querySelector('[data-hauer-garage-data]');
      try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
    }
    function modelLabel(m) { return G && G.modelLabel ? G.modelLabel(m) : String(m.title || '').replace(/\s*\(.*\)\s*$/, ''); }
    function yearsOf(m) {
      var ys = G && G.yearsFor ? G.yearsFor(m) : (m.years || []);
      return ys.filter(function (y) { return /^\d{4}$/.test(String(y.value)); }).map(function (y) { return { y: +y.value, url: y.url || '' }; });
    }
    function handleOf(url) { return ((String(url || '').split('?')[0].match(/\/collections\/([^/?#]+)/) || [])[1]) || ''; }
    // Anos desta peça (faixa aberta vai até o ano que vem; sem anos, uma faixa larga para o cliente escolher).
    function productYears() {
      var ys = years.map(Number).filter(Boolean);
      if (!ys.length) { for (var y = THIS_YEAR + 1; y >= 1995; y--) ys.push(y); return ys; }
      var lo = Math.min.apply(null, ys), hi = Math.max.apply(null, ys);
      // Faixa aberta vai até o ano-modelo que vem; tags além disso (2029 em alguns produtos) não viram opção (A-02).
      if (D.open) hi = THIS_YEAR + 1;
      hi = Math.min(hi, THIS_YEAR + 1);
      var out = []; for (var k = hi; k >= lo; k--) out.push(k);
      return out;
    }
    var MAKES = [];
    (function buildMakes() {
      garageData().forEach(function (b) {
        var mk = { name: String(b.title || '').replace(/&amp;/g, '&'), url: b.url, models: [] }, idx = {};
        (b.models || []).forEach(function (m) {
          var label = modelLabel(m).replace(/&amp;/g, '&');
          var k = norm(label); if (!k) return;
          if (!idx[k]) { idx[k] = { name: label, entries: [] }; mk.models.push(idx[k]); }
          idx[k].entries.push({ title: m.title, url: m.url, handle: handleOf(m.url), years: yearsOf(m) });
        });
        if (mk.models.length) MAKES.push(mk);
      });
    })();
    function findMake(n) { var k = norm(n); for (var i = 0; i < MAKES.length; i++) if (norm(MAKES[i].name) === k) return MAKES[i]; return null; }
    function findModel(mk, n) { if (!mk) return null; var k = norm(n); for (var i = 0; i < mk.models.length; i++) if (norm(mk.models[i].name) === k) return mk.models[i]; return null; }
    function modelYearList(md) {
      var set = {};
      md.entries.forEach(function (e) { e.years.forEach(function (y) { set[y.y] = 1; }); });
      var list = Object.keys(set).map(Number);
      if (!list.length) { if (md.own) return productYears(); for (var y = THIS_YEAR + 1; y >= 1990; y--) list.push(y); }
      return list.sort(function (a, b) { return b - a; });
    }
    function entryFor(md, year) {
      var hit = null;
      md.entries.forEach(function (e) { if (!hit && e.years.some(function (y) { return y.y === +year; })) hit = e; });
      return hit || md.entries[0] || null;
    }
    // A moto desta peça no menu (tags), ou montada do título quando o menu não a tem (A-08).
    var OWN = (function () {
      var best = null;
      // 02/11/2026: mesma regra do encaixe (bikeOk, tags ou título). Entre as motos que casam, prefere a do menu cuja
      // coleção lista esta peça (D.cols); a coleção só escolhe a pré-seleção, nunca prova encaixe.
      [true, false].forEach(function (byCol) {
        MAKES.forEach(function (mk) {
          mk.models.forEach(function (md) {
            if (best) return;
            var hit = byCol ? md.entries.filter(function (e) { return e.handle && (D.cols || []).indexOf(e.handle) > -1; })[0] : null;
            if (byCol ? (hit && bikeOk({ brand: mk.name, model: md.name, handle: hit.handle })) : bikeOk({ brand: mk.name, model: md.name })) best = { make: mk, model: md };
          });
        });
      });
      if (best) return best;
      if (!D.bike) return null;
      var bikeL = String(D.bike).toLowerCase(), brand = '';
      MAKES.forEach(function (mk) { if (!brand && bikeL.indexOf(mk.name.toLowerCase() + ' ') === 0) brand = mk.name; });
      if (!brand) { var first = String(D.bike).split(' ')[0]; if (first && tagsN.indexOf(norm(first)) > -1) brand = first; }
      if (!brand) return null;
      var model = String(D.bike).slice(brand.length).trim();
      if (!model) return null;
      if (tagsN.indexOf(norm(model)) < 0) {
        // Prefere a tag de modelo mais parecida com o título, para as outras páginas reconhecerem a moto.
        var mN = norm(model), pick = '';
        tags.forEach(function (t) {
          if (/^\d{4}$/.test(t) || t.indexOf(':') > -1 || /esr\d+/i.test(t) || norm(t) === norm(brand)) return;
          var tn = norm(t);
          if (tn.length >= 2 && (mN.indexOf(tn) > -1 || tn.indexOf(mN) > -1) && tn.length > norm(pick).length) pick = t;
        });
        if (pick) model = pick;
      }
      var mk = findMake(brand);
      if (!mk) { mk = { name: brand, url: '', models: [] }; MAKES.push(mk); MAKES.sort(function (a, b) { return a.name.localeCompare(b.name); }); }
      var md = findModel(mk, model);
      if (!md) { md = { name: model, entries: [{ title: model, url: '', handle: '', years: [] }], own: true }; mk.models.push(md); }
      return { make: mk, model: md };
    })();

    /* ================= Encaixe ================= */
    function evalFit(g) {
      // Peça universal (título/tag "universal", 24/09/2026): não depende da moto e não trava a compra.
      if (D.universal) return 'universal';
      if (!g) return 'none';
      // Moto montada a partir desta peça (fora do menu, A-08): marca e modelo conferem por definição.
      var own = g.source === 'product' && g.product === D.handle;
      if (!own && !bikeOk(g)) return 'no';
      if (D.allYears) return 'yes';
      // 03/11/2026 (teste de compra): peça sem ano cadastrado. Mesma regra de HauerGarage.fitState (cards e carrinho):
      // marca e modelo conferem, o ano não dá para conferir -> 'check'. Antes dizia "Fits your 2016 ..." sem saber o ano.
      if (!years.length) {
        if (D.open) return 'yes';
        var ySet = /^\d{4}$/.test(String(g.year || ''));
        return ySet || (typeof g.y2 === 'number' && g.y2 > 0) ? 'check' : 'yes';
      }
      // Sem ano: nunca chuta. Pergunta o ano (a maquete: "Which year is your ...?").
      if (!/^\d{4}$/.test(String(g.year || ''))) return 'needyear';
      if (years.indexOf(String(g.year)) > -1) return 'yes';
      // Faixa aberta ("2023-on", A-02): qualquer ano a partir do mínimo encaixa.
      if (D.open && D.yMin && +g.year >= +D.yMin) return 'yes';
      return 'year';
    }
    function mName(g) { return String(g && g.model || '').replace(/\s*\|\s*/g, ' / '); }
    function bikeLabel(g) { return G && G.label ? G.label(g) : [g.brand, g.model, /^\d{4}$/.test(String(g.year)) ? g.year : ''].filter(Boolean).join(' '); }
    function shortYears(s) { return s.open === 'open' ? s.y1 + '+' : s.open === 'all' ? '' : (s.y1 === s.y2 ? String(s.y1) : s.y1 + '-' + s.y2); }
    function sibFits(s, y) { return s.open === 'all' || (y >= s.y1 && (s.open === 'open' || y <= s.y2)); }
    function kitsFor(y) {
      return (D.sibs || []).filter(function (s) { return sibFits(s, y); }).sort(function (a, b) { return (b.available - a.available) || (b.y1 - a.y1); });
    }
    function typeQuery() { return D.type ? D.filterParam + '=' + encodeURIComponent(D.type) : ''; }
    function bikePageUrl(g, withType) {
      var base = String(D.rootUrl || '/').replace(/\/$/, '');
      var q = withType ? typeQuery() : '';
      if (g && g.handle && G && G.bikeUrl) return base + G.bikeUrl(g, q);
      if (g && g.handle) return base + '/collections/' + g.handle + (q ? '?' + q : '');
      return base + '/search?q=' + encodeURIComponent([g && g.brand, g && g.model, withType ? D.typeLabel : ''].filter(Boolean).join(' '));
    }

    /* ---------- selects ---------- */
    function opts(sel, items, ph, val) {
      sel.innerHTML = '<option value="">' + esc(ph) + '</option>' + items.map(function (it) { return '<option value="' + esc(it) + '"' + (String(it) === String(val) ? ' selected' : '') + '>' + esc(it) + '</option>'; }).join('');
      sel.classList.toggle('is-empty', !sel.value);
    }
    function fillMakes(val) { opts(selMake, MAKES.map(function (m) { return m.name; }), T.labelMake, val); }
    function fillModels(val) { var mk = findMake(selMake.value); opts(selModel, mk ? mk.models.map(function (m) { return m.name; }) : [], T.labelModel, mk && findModel(mk, val) ? findModel(mk, val).name : ''); selModel.disabled = !mk; }
    function fillYears(val) { var md = findModel(findMake(selMake.value), selModel.value); opts(selYear, md ? modelYearList(md) : [], T.labelYear, val); selYear.disabled = !md; }
    function clearErr() { fitErr.hidden = true; [selMake, selModel, selYear].forEach(function (s) { s.classList.remove('is-missing'); s.classList.toggle('is-empty', !s.value); }); }
    selMake.addEventListener('change', function () { fillModels(''); fillYears(''); clearErr(); });
    selModel.addEventListener('change', function () { fillYears(''); clearErr(); });
    selYear.addEventListener('change', clearErr);
    function prefill(g) {
      var mkName = g && g.brand ? (findMake(g.brand) || {}).name : '';
      var mdName = g && g.model ? g.model : '';
      if (!mkName && OWN) { mkName = OWN.make.name; mdName = OWN.model.name; }
      fillMakes(mkName || ''); fillModels(mdName || ''); fillYears(g && /^\d{4}$/.test(String(g.year || '')) ? g.year : '');
      clearErr();
    }
    fitForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var miss = [selMake, selModel, selYear].filter(function (s) { return !s.value; });
      if (miss.length) {
        miss.forEach(function (s) { s.classList.add('is-missing'); });
        fitErr.hidden = false;
        fitErr.textContent = miss[0] === selYear ? T.errYear : miss[0] === selMake ? T.errMake : T.errModel;
        miss[0].focus();
        return;
      }
      var mk = findMake(selMake.value), md = findModel(mk, selModel.value);
      var e1 = md ? entryFor(md, selYear.value) : null;
      var g = { brand: mk.name, model: md.name, year: String(selYear.value), handle: e1 ? e1.handle : '' };
      if (md.own) { g.source = 'product'; g.product = D.handle; }
      var yUrl = ''; if (e1) e1.years.forEach(function (y) { if (y.y === +g.year && y.url && y.url !== e1.url) yUrl = y.url; });
      g.url = yUrl || (g.handle && G && G.bikeUrl ? G.bikeUrl(g) : '');
      state.editing = false; state.override = null; state.focusResult = true;
      track('fit_check', { handle: D.handle, brand: g.brand, model: g.model, year: g.year, result: evalFit(g) });
      if (G && typeof G.write === 'function') G.write(g, 'pdp_selector');
      else { try { localStorage.setItem('hauer:garage', JSON.stringify(g)); } catch (err) { /* segue sem salvar */ } paintFit(); }
    });
    fitCancel.addEventListener('click', function () { state.editing = false; paintFit(); });

    /* ---------- moto fora da lista: confirmação do cliente ---------- */
    function nlError(on) {
      if (nlErr) nlErr.hidden = !on;
      if (nlBike) { if (on) nlBike.setAttribute('aria-invalid', 'true'); else nlBike.removeAttribute('aria-invalid'); }
    }
    if (nlBike) {
      nlBike.addEventListener('input', function () { if (String(nlBike.value || '').trim()) nlError(false); });
      // Enter no campo confirma a moto (sem isso o Enter enviaria o formulário Make / Model / Year).
      nlBike.addEventListener('keydown', function (e) { if (e.key === 'Enter' && nlBtn) { e.preventDefault(); nlBtn.click(); } });
    }
    if (nlBtn) nlBtn.addEventListener('click', function () {
      var txt = nlBike ? String(nlBike.value || '').trim().slice(0, 60) : '';
      // Sem a moto escrita não há o que gravar no pedido: pede a moto antes de liberar a compra (24/09/2026).
      if (!txt) { nlError(true); if (nlBike) nlBike.focus(); return; }
      nlError(false);
      state.override = { text: txt };
      state.editing = false; state.focusResult = true;
      if (nlBox) nlBox.open = false;
      track('fit_override', { handle: D.handle, bike: txt, source: 'not_listed' });
      paintFit();
    });

    /* ---------- painel ---------- */
    function resRow(left) { return '<div class="hp-res__row">' + left + '<button type="button" class="hp-linkbtn" data-hp-change>' + esc(T.changeBike) + '</button></div>'; }
    function kitCard(href, img, t, m, btn, red, attrs) {
      return '<a class="hp-kit" href="' + esc(href) + '" ' + (attrs || '') + '>' + (img ? '<img src="' + esc(img) + '" alt="" width="84" height="84" loading="lazy">' : '<span class="hp-kit__ico">' + ICON.bike + '</span>') +
        '<span><span class="hp-kit__t">' + esc(t) + '</span><span class="hp-kit__m">' + esc(m) + '</span>' +
        '<span class="hauer-btn ' + (red ? 'hauer-btn--red' : 'hauer-btn--dark') + ' hp-kit__go">' + esc(btn) + ' →</span></span></a>';
    }
    function paintFit() {
      state.garage = G && G.read ? G.read() : (function () { try { return JSON.parse(localStorage.getItem('hauer:garage') || 'null'); } catch (e) { return null; } })();
      var g = state.garage;
      var f = evalFit(g);
      state.fit = f;
      var ov = !!state.override;
      var showForm = state.editing || (!ov && (f === 'none' || f === 'needyear'));
      fitBox.classList.toggle('is-ok', !showForm && !ov && (f === 'yes' || f === 'universal'));
      fitBox.classList.toggle('is-no', !showForm && !ov && (f === 'year' || f === 'no'));
      fitBox.classList.toggle('is-chk', !showForm && !ov && f === 'check');
      fitBox.classList.toggle('is-ov', !showForm && ov);
      fitForm.hidden = !showForm; fitRes.hidden = showForm;
      fitCancel.hidden = !(state.editing && (g || ov));
      var yrs = D.yearsLabel || '';
      if (showForm) {
        prefill(g);
        fitTitle.textContent = T.fitTitle; fitSub.textContent = T.fitSub;
        if (f === 'needyear' && !state.editing) fitAsk.innerHTML = esc(T.fitAskYear).replace('{bike}', '<b>' + esc([g.brand, mName(g)].join(' ')) + '</b>');
        else fitAsk.textContent = state.editing && (g || state.override) ? T.fitAskEdit : T.fitAsk;
      } else if (ov) {
        fitTitle.textContent = T.ovTitle; fitSub.textContent = T.ovSub;
        var waA = D.whatsapp ? '<a href="' + esc(D.whatsapp) + '" target="_blank" rel="noopener">WhatsApp</a>' : 'WhatsApp';
        fitRes.innerHTML = '<div class="hp-res"><span class="hp-res__ico">' + ICON.ok + '</span>' +
          '<p class="hp-res__big">' + esc(fill(T.ovBig, { bike: state.override.text })) + '</p>' +
          '<p class="hp-res__small">' + esc(T.ovSmall).replace('{whatsapp}', waA) + '</p>' +
          '<div class="hp-res__row"><span></span><button type="button" class="hp-linkbtn" data-hp-change>' + esc(T.ovUndo) + '</button></div></div>';
      } else if (f === 'universal') {
        fitTitle.textContent = T.uniTitle; fitSub.textContent = T.uniSub;
        var waU = D.whatsapp ? '<a href="' + esc(D.whatsapp) + '" target="_blank" rel="noopener">WhatsApp</a>' : 'WhatsApp';
        fitRes.innerHTML = '<div class="hp-res"><span class="hp-res__ico">' + ICON.ok + '</span>' +
          '<p class="hp-res__big">' + esc(T.uniBig) + '</p>' +
          '<p class="hp-res__small">' + esc(T.uniSmall).replace('{whatsapp}', waU) + '</p></div>';
      } else if (f === 'yes') {
        fitTitle.textContent = T.okTitle; fitSub.textContent = T.okSub;
        var label = bikeLabel(g);
        // 02/11/2026: apelidos do menu com " / " ("ZX-6R / RR"), como no label() dos cards
        var yLabel = /^\d{4}$/.test(String(g.year)) ? g.year + ' ' + g.brand + ' ' + String(g.model || '').replace(/\s*\|\s*/g, ' / ') : label;
        fitRes.innerHTML = '<div class="hp-res"><span class="hp-res__ico">' + ICON.ok + '</span>' +
          '<p class="hp-res__big">' + esc(fill(T.okBig, { bike: yLabel })) + '</p>' +
          '<p class="hp-res__small">' + esc(D.isKit && yrs ? fill(T.okSmallKit, { years: yrs }) : D.fits ? fill(T.okSmall, { fits: D.fits }) : '') + '</p>' +
          resRow('<span class="hp-guar">' + ICON.shield + esc(T.guarantee) + '</span>') + '</div>';
      } else if (f === 'check') {
        // 03/11/2026: modelo confere, ano não listado na peça. Compra normal; o cliente confirma o ano se tiver dúvida.
        fitTitle.textContent = T.chkTitle; fitSub.textContent = T.chkSub;
        var waC = D.whatsapp ? '<a href="' + esc(D.whatsapp) + '" target="_blank" rel="noopener">WhatsApp</a>' : 'WhatsApp';
        var mLabel = [g.brand, String(g.model || '').replace(/\s*\|\s*/g, ' / ')].filter(Boolean).join(' ');
        fitRes.innerHTML = '<div class="hp-res"><span class="hp-res__ico">' + ICON.q + '</span>' +
          '<p class="hp-res__big">' + esc(fill(T.chkBig, { model: mLabel })) + '</p>' +
          '<p class="hp-res__small">' + esc(fill(T.chkSmall, { bike: bikeLabel(g), fits: D.fits, whatsapp: '{whatsapp}' })).replace('{whatsapp}', waC) + '</p>' +
          resRow('<span></span>') + '</div>';
      } else if (f === 'year') {
        var y = +g.year, kits = kitsFor(y), main = kits[0];
        fitTitle.textContent = D.isKit ? T.yearTitleKit : T.yearTitle;
        fitSub.textContent = main ? T.yearSubFound : T.helpSub;
        var big = main ? fill(D.isKit ? T.yearBigKit : T.yearBig, { years: yrs, year: y, kit: shortYears(main) }) : fill(D.isKit ? T.yearBigKitNone : T.yearBigNone, { years: yrs, year: y });
        var html = '<div class="hp-res"><span class="hp-res__ico">' + ICON.no + '</span>' +
          '<p class="hp-res__big">' + esc(big) + '</p>' +
          '<p class="hp-res__small">' + esc(D.isKit ? T.yearSmallKit : T.yearSmall) + '</p>';
        kits.slice(0, 2).forEach(function (k, i) {
          html += kitCard(k.url, k.img, k.part + ' · ' + k.bike + ' ' + k.years, fill(T.kitMeta, { price: money(k.price, D.money), year: y }), fill(D.isKit ? T.kitBtnKit : T.kitBtn, { kit: shortYears(k) }), i === 0, 'data-hp-kit');
        });
        if (!kits.length) {
          var tl = D.typeLabel || D.type || '';
          html += kitCard(bikePageUrl(g, true), '', fill(T.yearFbT, { type: tl, year: y, model: mName(g) }), T.yearFbM, fill(T.yearFbBtn, { type: tl.toLowerCase(), year: y }), true, 'data-hp-kit');
        }
        html += resRow('<span>' + esc(T.yearRow) + '</span>') + '</div>';
        fitRes.innerHTML = html;
      } else if (f === 'no') {
        fitTitle.textContent = T.noTitle; fitSub.textContent = T.helpSub;
        var lbl = bikeLabel(g);
        fitRes.innerHTML = '<div class="hp-res"><span class="hp-res__ico">' + ICON.no + '</span>' +
          '<p class="hp-res__big">' + esc(D.fits || D.bike ? fill(T.noBig, { fits: D.fits || D.bike }) : fill(T.noBigNone, { model: mName(g) })) + '</p>' +
          '<p class="hp-res__small">' + esc(fill(D.isKit ? T.noSmallKit : T.noSmall, { bike: lbl })) + '</p>' +
          kitCard(bikePageUrl(g, false), '', fill(T.noCardT, { model: mName(g) }), fill(T.noCardM, { type: D.typeLabel || D.type || '', bike: lbl }), fill(T.noCardBtn, { model: mName(g) }), true, 'data-hp-kit') +
          '<div class="hp-res__row"><span>' + esc(T.noRow) + '</span><button type="button" class="hp-linkbtn" data-hp-change>' + esc(T.changeBike) + '</button></div></div>';
      }
      var ch = $('[data-hp-change]', fitRes);
      if (ch) ch.addEventListener('click', function () {
        state.editing = true; if (state.override) state.override = null;
        paintFit(); focusNoScroll(selYear.value || !selModel.value ? selMake : selYear);
      });
      if (state.focusResult && !showForm) { state.focusResult = false; var bigEl = $('.hp-res__big', fitRes); if (bigEl) { bigEl.setAttribute('tabindex', '-1'); focusNoScroll(bigEl); } }
      // A moto confirmada (ou a confirmação do cliente) vai no pedido (A-13); sem confirmação o campo nem é enviado.
      if (bikeProp) {
        var bv = '';
        if (state.override) bv = fill(T.bikeOverride, { bike: state.override.text });
        else if (f === 'yes') bv = bikeLabel(g);
        else if (f === 'check') bv = fill(T.bikeCheck, { bike: bikeLabel(g) });
        bikeProp.value = bv; bikeProp.disabled = !bv;
      }
      track('fit_result', { status: ov ? 'override' : f, bike: g ? bikeLabel(g) : '', handle: D.handle });
      paintTable();
      paintAll();
    }
    fitRes.addEventListener('click', function (e) {
      var a = e.target.closest('[data-hp-kit]');
      if (a) track('fit_year_redirect', { handle: D.handle, year: state.garage && state.garage.year, status: state.fit, to: a.getAttribute('href') });
    });
    document.addEventListener('hauer:garage:change', function () { if (!root.isConnected) return; state.editing = false; state.override = null; paintFit(); });
    // Chip "Set my bike / Change" do header (A-09): abre o painel aqui mesmo, sem sair da página.
    document.addEventListener('hauer:garage:open', function (e) {
      if (!root.isConnected) return;
      e.preventDefault();
      state.editing = true; paintFit();
      fitBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { focusNoScroll(selMake); }, 350);
    });

    /* ================= Tabela de encaixe (A-12): linha do ano do cliente ================= */
    function paintTable() {
      var tb = $('[data-hp-tbl] tbody'); if (!tb) return;
      var g = state.garage, f = state.fit;
      var y = g && /^\d{4}$/.test(String(g.year)) ? +g.year : 0;
      var active = y && (f === 'yes' || f === 'year');
      $$('tr', tb).forEach(function (tr) {
        var mine = false;
        if (active) {
          if (tr.dataset.y1) mine = sibFits({ y1: +tr.dataset.y1, y2: +tr.dataset.y2 || +tr.dataset.y1, open: tr.dataset.open || '' }, y);
          else if (tr.dataset.yearsText) {
            var m = /(\d{4})\D+(\d{4}|on|up|newer|\+)?/i.exec(tr.dataset.yearsText) || /(\d{4})/.exec(tr.dataset.yearsText);
            if (m) { var a = +m[1], b = m[2] && /^\d{4}$/.test(m[2]) ? +m[2] : (m[2] ? 9999 : a); mine = y >= a && y <= b; }
          }
          if (f === 'year' && tr.classList.contains('is-this')) mine = false;
        }
        tr.classList.toggle('is-mine', mine);
        var slot = $('[data-hp-mine]', tr);
        if (slot) slot.innerHTML = mine ? ' <span class="hp-pill hp-pill--mine">' + esc(fill(T.mine, { year: y })) + '</span>' : '';
      });
    }

    /* ================= Opções / variante ================= */
    function matches(v, idx, val) { return v.options[idx] === val && v.options.every(function (o, i) { return i === idx || selected[i] == null || o === selected[i]; }); }
    function valueInfo(idx, val) {
      var list = D.variants.filter(function (v) { return matches(v, idx, val); });
      var avail = list.some(function (v) { return v.available; });
      var sale = list.filter(function (v) { return v.compare > v.price; });
      var low = null; sale.forEach(function (v) { if (!low || v.price < low.price) low = v; });
      return { avail: avail, sale: !!sale.length && sale.length === list.length, low: low };
    }
    optBoxes.forEach(function (box) {
      var idx = +box.dataset.optionIndex;
      var sw = $('.hp-sw', box);
      var isColor = box.dataset.color === 'true';
      var anyMatte = false;
      $$('.hp-swb', sw).forEach(function (b) {
        if (!isColor) return;
        var c = colorFor(b.dataset.value);
        if (c) { b.style.setProperty('--c', c); if (!/matte/i.test(b.dataset.value)) b.classList.add('is-gloss'); else anyMatte = true; }
        else b.classList.add('is-unknown');
      });
      if (isColor && anyMatte) { var cnt = $('[data-hp-optcount]', box); if (cnt) cnt.textContent = cnt.textContent + ' · ' + T.glossMatte; }
      sw.addEventListener('click', function (e) { var b = e.target.closest('.hp-swb'); if (b) pick(idx, b.dataset.value, b); });
      // Hover mostra o nome da cor antes do clique (maquete); sair volta ao escolhido.
      sw.addEventListener('mouseover', function (e) { var b = e.target.closest('.hp-swb'); if (b) paintOptVal(box, idx, b.dataset.value); });
      sw.addEventListener('mouseleave', function () { paintOptVal(box, idx); });
      // tabindex rotativo + setas (A-14)
      sw.addEventListener('keydown', function (e) {
        var delta = { ArrowLeft: -1, ArrowUp: -1, ArrowRight: 1, ArrowDown: 1 }[e.key];
        var btns = $$('.hp-swb', sw); if (!btns.length) return;
        var i = btns.indexOf(document.activeElement), n;
        if (delta) n = ((i < 0 ? 0 : i) + delta + btns.length) % btns.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = btns.length - 1;
        else return;
        e.preventDefault(); btns[n].focus(); btns[n].click();
      });
      var saleLine = $('[data-hp-saleline]', box);
      if (saleLine) saleLine.addEventListener('click', function (e) { var b = e.target.closest('[data-hp-pick]'); if (!b) return; var t = $$('.hp-swb', sw).filter(function (x) { return x.dataset.value === b.dataset.hpPick; })[0]; if (t) { t.focus(); t.click(); } });
      // Pré-carrega a foto da variante ao passar o mouse / focar (troca sem piscar).
      var pre = {};
      ['pointerover', 'focusin'].forEach(function (ev) {
        sw.addEventListener(ev, function (e) {
          var b = e.target.closest && e.target.closest('.hp-swb'); if (!b || pre[b.dataset.value]) return;
          var v = D.variants.filter(function (x) { return matches(x, idx, b.dataset.value) && x.media; })[0];
          var m = v && mediaById[v.media]; if (m) { pre[b.dataset.value] = new Image(); pre[b.dataset.value].src = m.src; }
        }, { passive: true });
      });
    });
    function paintOptVal(box, idx, preview) {
      var el = $('[data-hp-optval]', box); if (!el) return;
      var val = preview || selected[idx];
      el.classList.toggle('is-empty', !val);
      if (!val) { el.textContent = T.optChoose; return; }
      var inf = valueInfo(idx, val);
      var btn = $$('.hp-swb', box).filter(function (b) { return b.dataset.value === val; })[0];
      var tEl = btn ? btn.querySelector('.hp-swb__t') : null;
      var shown = tEl ? tEl.textContent : val;
      el.innerHTML = esc(shown) + (inf.sale && inf.low ? ' <span class="tag">· ' + esc(fill(T.saleTag, { price: money(inf.low.price, D.money) })) + '</span>' : '') + (!inf.avail ? ' <span class="tag">· ' + esc(T.soldValue) + '</span>' : '');
    }
    function pick(idx, val, btn) {
      selected[idx] = val;
      var box = optBoxes.filter(function (b) { return +b.dataset.optionIndex === idx; })[0];
      $$('.hp-swb', box).forEach(function (x) { var on = x === btn; x.setAttribute('aria-checked', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1; });
      resolveVariant(true);
      track('variant_select', { handle: D.handle, option: D.options[idx], value: val });
    }
    function paintOptions() {
      var saleShown = false;
      optBoxes.forEach(function (box) {
        var idx = +box.dataset.optionIndex;
        var btns = $$('.hp-swb', box), anyOn = false;
        var saleVals = [];
        btns.forEach(function (b) {
          var inf = valueInfo(idx, b.dataset.value);
          b.classList.toggle('is-unavailable', !inf.avail);
          b.setAttribute('aria-disabled', inf.avail ? 'false' : 'true');
          var sl = $('.hp-swb__sale', b); if (sl) sl.hidden = !inf.sale;
          var base = b.querySelector('.hp-swb__t') ? b.querySelector('.hp-swb__t').textContent : b.dataset.value;
          b.setAttribute('aria-label', base + (inf.sale && inf.low ? ', ' + fill(T.saleTag, { price: money(inf.low.price, D.money) }) : '') + (!inf.avail ? ', ' + T.soldValue : ''));
          b.title = b.getAttribute('aria-label');
          if (b.getAttribute('aria-checked') === 'true') anyOn = true;
          if (inf.sale && inf.low) saleVals.push({ v: b.dataset.value, low: inf.low });
        });
        if (!anyOn && btns.length) btns.forEach(function (b, i) { b.tabIndex = i === 0 ? 0 : -1; });
        paintOptVal(box, idx);
        // Linha "On sale: Orange and Pink, $159 $229" quando só algumas opções estão em promoção.
        var line = $('[data-hp-saleline]', box);
        if (line) {
          var show = !saleShown && saleVals.length && saleVals.length < btns.length;
          line.hidden = !show;
          if (show) {
            saleShown = true;
            var low = saleVals[0].low; saleVals.forEach(function (s) { if (s.low.price < low.price) low = s.low; });
            var names = saleVals.map(function (s) { return '<button type="button" data-hp-pick="' + esc(s.v) + '">' + esc(s.v) + '</button>'; });
            var list = names.length > 1 ? names.slice(0, -1).join(', ') + ' ' + esc(T.and) + ' ' + names[names.length - 1] : names[0];
            line.innerHTML = '<span class="dot" aria-hidden="true"></span>' + esc(T.saleLine).replace('{list}', list).replace('{price}', '<b>' + esc(money(low.price, D.money)) + '</b>').replace('{was}', '<s>' + esc(money(low.compare, D.money)) + '</s>');
          }
        }
      });
    }
    function partialVariant() {
      if (!selected.some(function (v) { return v != null; })) return null;
      var list = D.variants.filter(function (v) { return v.options.every(function (o, i) { return selected[i] == null || o === selected[i]; }); });
      return list.filter(function (v) { return v.media; })[0] || null;
    }
    function resolveVariant(fromPick) {
      if (D.onlyDefault) { variant = D.variants[0]; paintAll(); return; }
      variant = null;
      if (selected.every(function (v) { return v != null; })) {
        D.variants.forEach(function (v) { if (!variant && v.options.every(function (o, i) { return o === selected[i]; })) variant = v; });
      }
      // O formulário só leva o id da variante quando ela existe (Shop Pay / PayPal compram o que está aqui).
      if (input) input.disabled = !variant;
      if (variant) {
        if (input) input.value = variant.id;
        if (instInput) { instInput.value = variant.id; instInput.dispatchEvent(new Event('change', { bubbles: true })); }
        try { var u = new URL(window.location.href); u.searchParams.set('variant', variant.id); window.history.replaceState({}, '', u.toString()); } catch (e) { /* file:// */ }
      }
      buildGallery(fromPick);
      paintAll();
    }

    /* ================= Galeria ================= */
    var mediaById = {}; (D.media || []).forEach(function (m) { mediaById[m.id] = m; });
    var baseMedia = (D.media || []).filter(function (m) { return !m.attached; });
    if (!baseMedia.length) baseMedia = (D.media || []).slice();
    function galItems() {
      var list = baseMedia.slice();
      var v = variant || partialVariant();
      var m = v && v.media ? mediaById[v.media] : null;
      // 03/11/2026: produto em que TODAS as fotos são de variante (attached false em todas): a da cor escolhida vai para a frente
      if (m) { list = list.filter(function (x) { return x.id !== m.id; }); list.unshift(Object.assign({}, m, { tag: true })); }
      return list;
    }
    function hideVideos() {
      galVids.forEach(function (w) {
        var wasOpen = !w.hidden;
        w.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (e) { /* noop */ } });
        if (wasOpen) w.querySelectorAll('iframe').forEach(function (f) { var s = f.getAttribute('src'); if (s) f.setAttribute('src', s); });
        w.hidden = true;
      });
    }
    function showIdx(i) {
      var list = state.gal; if (!list.length || !mainImg) return;
      state.idx = (i + list.length) % list.length;
      var m = list[state.idx];
      var isVid = m.type === 'video' || m.type === 'external_video';
      var wrap = null;
      if (isVid) galVids.forEach(function (w) { if (String(w.dataset.mediaId) === String(m.id)) wrap = w; });
      hideVideos();
      if (wrap) { wrap.hidden = false; }
      else if (mainImg.getAttribute('src') !== m.src) {
        mainImg.classList.add('is-fading');
        var done = function () { mainImg.classList.remove('is-fading'); };
        mainImg.onload = done; setTimeout(done, 400);
        mainImg.removeAttribute('srcset'); mainImg.src = m.src;
      }
      mainImg.alt = m.alt || '';
      mainImg.classList.toggle('is-contain', !!m.contain);
      if (galCnt) galCnt.textContent = (state.idx + 1) + ' / ' + list.length;
      if (thumbs) $$('.hp-thumb', thumbs).forEach(function (b, j) {
        if (j === state.idx) { b.setAttribute('aria-current', 'true'); var r = thumbs.getBoundingClientRect(), br = b.getBoundingClientRect(); if (br.left < r.left || br.right > r.right) thumbs.scrollLeft += br.left - r.left - 8; }
        else b.removeAttribute('aria-current');
      });
      // Variante sem foto própria: aviso honesto na foto.
      var chosen = variant || null;
      if (galCap) {
        var noPhoto = chosen && !chosen.media && !D.onlyDefault;
        galCap.hidden = !noPhoto;
        if (noPhoto) galCap.textContent = fill(T.galNoPhoto, { value: chosen.options.join(' / ') });
      }
    }
    function buildGallery(fromPick) {
      var list = galItems();
      // 03/11/2026: a marca "Your pick" entra na assinatura: a capa também pode ser a foto da cor escolhida (fica no mesmo lugar)
      var sig = list.map(function (m) { return m.id + (m.tag ? '*' : ''); }).join(',');
      if (sig !== state.gSig) {
        state.gSig = sig; state.gal = list;
        if (thumbs) {
          thumbs.innerHTML = list.map(function (m, i) {
            var vid = m.type === 'video' || m.type === 'external_video';
            return '<button type="button" class="hp-thumb" role="listitem" data-ti="' + i + '" aria-label="' + esc(fill(T.galPhoto, { n: i + 1 })) + (m.tag ? ' · ' + esc(T.galPick) : '') + (vid ? ' · ' + esc(T.galPlay) : '') + '">' +
              '<img src="' + esc(m.thumb) + '" alt="" width="76" height="76" loading="lazy"' + (m.contain ? ' class="is-contain"' : '') + '>' +
              (vid ? '<span class="hp-thumb__play" aria-hidden="true"><i><svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg></i></span>' : '') +
              (m.tag ? '<span class="hp-thumb__tag">' + esc(T.galPick) + '</span>' : '') + '</button>';
          }).join('');
        }
        state.idx = 0;
      }
      if (fromPick) state.idx = list[0] && list[0].tag ? 0 : state.idx;
      if (fromPick || state.firstGal) showIdx(state.idx);
      state.firstGal = false;
    }
    if (thumbs) thumbs.addEventListener('click', function (e) { var b = e.target.closest('[data-ti]'); if (b) showIdx(+b.dataset.ti); });
    var prevB = $('[data-hp-prev]'), nextB = $('[data-hp-next]');
    if (prevB) prevB.addEventListener('click', function () { showIdx(state.idx - 1); });
    if (nextB) nextB.addEventListener('click', function () { showIdx(state.idx + 1); });
    if (mainImg) (function () {
      var x0 = null;
      mainImg.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      mainImg.addEventListener('touchend', function (e) {
        if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) showIdx(state.idx + (dx < 0 ? 1 : -1));
      });
    })();

    /* ================= Entrega (A-04) ================= */
    // D.madeSignal "inventory_first" (padrão): estoque Shopify decide quando a variante é rastreada; a tag
    // (D.madeTag) só vale sem rastreio. "tag_first": tag primeiro, depois o estoque.
    function madeToOrder(v) {
      var byTag = !!(D.madeTag && tags.indexOf(D.madeTag) > -1);
      var tracked = !!(v && v.mgmt === 'shopify');
      var byStock = !!(tracked && v.qty <= 0 && v.policy === 'continue');
      if (D.madeSignal === 'tag_first') return byTag || byStock;
      return tracked ? byStock : byTag;
    }
    function shipDate() {
      if (G && typeof G.shipDate === 'function') return G.shipDate(D.madeDays);
      var n = parseInt(D.madeDays, 10) || 10, d = new Date();
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
      try { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); } catch (e) { return ''; }
    }
    var tsTitle = host.querySelector('[data-hauer-trust-ship-title]'), tsSub = host.querySelector('[data-hauer-trust-ship-sub]');
    function productAvailable() { return D.variants.some(function (v) { return v.available; }); }
    function paintPromise() {
      var avail = variant ? variant.available : productAvailable();
      var made = madeToOrder(variant || D.variants[0]);
      var st = !avail ? 'sold' : made ? 'made' : 'stock';
      var vars = { vendor: D.vendor, days: D.madeDays, date: st === 'made' ? shipDate() : '', cutoff: cutoffLabel(D.cutoffHour) };
      if (promise) promise.dataset.state = st;
      if (pTitle && pText) {
        if (st === 'sold') { pTitle.textContent = T.pSoldTitle; pText.textContent = T.pSoldText; }
        else if (st === 'made') {
          pTitle.textContent = fill(T.pMadeTitle, vars);
          pText.innerHTML = esc(T.pMadeText).replace('{date}', '<b>' + esc(vars.date) + '</b>').replace(/\{(\w+)\}/g, function (_, k) { return esc(vars[k] || ''); });
        } else { pTitle.textContent = T.pStockTitle; pText.textContent = fill(T.pStockText, vars); }
      }
      if (tsTitle && tsSub) {
        var t = st === 'made' ? T.tsMadeTitle : st === 'sold' ? T.tsSoldTitle : T.tsStockTitle;
        var s = st === 'made' ? T.tsMadeSub : st === 'sold' ? T.tsSoldSub : T.tsStockSub;
        if (t) tsTitle.textContent = fill(t, vars);
        if (s) tsSub.textContent = fill(s, vars);
      }
      if (G && G.paintShipDates) { try { G.paintShipDates(root); } catch (e) { /* noop */ } }
      return st;
    }

    /* ================= Botão, preço, barra fixa ================= */
    function missingOption() { for (var i = 0; i < selected.length; i++) if (selected[i] == null) return i; return -1; }
    function optPhrase(i) { var n = String(D.options[i] || '').toLowerCase(); return (/^[aeiou]/.test(n) ? 'an ' : 'a ') + n; }
    function curPrice() { return variant ? variant.price : null; }
    function ctaModel() {
      var miss = D.onlyDefault ? -1 : missingOption();
      var g = state.garage, f = state.fit;
      if (miss > -1) return { cls: 'is-choose', text: fill(T.ctaChoose, { option: optPhrase(miss) }), short: fill(T.skChoose, { option: String(D.options[miss] || '').toLowerCase() }), act: 'opt', idx: miss };
      if (!variant || !variant.available) return { cls: 'is-sold', text: T.ctaSold, short: T.ctaSold, act: 'none' };
      var total = money(variant.price * state.qty, D.money);
      if ((f === 'year' || f === 'no') && !state.override) return { cls: 'is-warn', text: T.ctaAnyway, short: T.skSee, act: 'anyway', note: fill(T.ctaNote, { bike: bikeLabel(g) }), total: total };
      return { cls: '', text: fill(T.ctaAdd, { total: total }), short: fill(T.skAdd, { total: total }), act: 'add', total: total };
    }
    function paintAll() {
      paintOptions();
      var st = paintPromise();
      var m = ctaModel();
      var canSubmit = m.act === 'add' || m.act === 'anyway';
      // CTA travado por aria-disabled (A-14): continua focável; product-form.js não envia com aria-disabled.
      if (addBtn && !addBtn.classList.contains('is-loading')) {
        addBtn.setAttribute('aria-disabled', canSubmit ? 'false' : 'true');
        addBtn.className = 'hauer-btn hauer-btn--red hp-cta' + (m.cls ? ' ' + m.cls : '');
        addBtn.textContent = m.text; addBtn.dataset.addToCartText = m.text;
      }
      if (ctaNote) { ctaNote.hidden = !m.note; ctaNote.textContent = m.note || ''; }
      if (statusEl) {
        var choice = D.onlyDefault ? D.part : selected.filter(Boolean).join(' / ');
        statusEl.textContent = m.act === 'opt' ? fill(T.stChoose, { option: String(D.options[m.idx] || '').toLowerCase(), count: $$('.hp-swb', optBoxes[m.idx]).length })
          : m.act === 'none' ? T.stSold : m.act === 'anyway' ? T.stAnyway : fill(T.stReady, { choice: choice });
      }
      // Shop Pay / PayPal compram a variante do formulário: só com variante válida E moto confirmada (ou confirmada pelo cliente).
      var ready = !!(variant && variant.available && (state.fit === 'yes' || state.fit === 'check' || state.fit === 'universal' || state.override));
      if (express) {
        try { express.inert = !ready; } catch (e) { /* noop */ }
        if (!ready) express.setAttribute('inert', ''); else express.removeAttribute('inert');
        express.setAttribute('aria-hidden', String(!ready)); express.classList.toggle('is-locked', !ready); express.hidden = !ready;
      }
      if (expressNote) expressNote.hidden = ready;
      // Preço
      var price = curPrice();
      if (price != null && nowEl) {
        var cmp = variant.compare > variant.price ? variant.compare : 0;
        nowEl.textContent = money(price, D.money); nowEl.classList.toggle('is-sale', !!cmp);
        if (wasEl) { wasEl.hidden = !cmp; wasEl.textContent = cmp ? money(cmp, D.money) : ''; }
        if (saveEl) { saveEl.hidden = !cmp; saveEl.textContent = cmp ? fill(T.save, { amount: money(cmp - price, D.money) }) : ''; }
      }
      paintSticky(m);
      root.dataset.ready = canSubmit ? '1' : '';
      root.dataset.fit = state.override ? 'override' : state.fit;
      return st;
    }
    function paintSticky(m) {
      if (!sticky) return;
      var g = state.garage, f = state.fit;
      var cls = state.override ? 'is-ok' : (f === 'yes' || f === 'universal') ? 'is-ok' : (f === 'year' || f === 'no') ? 'is-no' : 'is-none';
      stSt.className = 'hp-sticky__st ' + cls;
      stSt.innerHTML = state.override ? ICON.ok + esc(T.skOv)
        : f === 'universal' ? ICON.ok + esc(T.skUni)
        : f === 'yes' ? ICON.ok + esc(fill(T.skOk, { bike: [/^\d{4}$/.test(String(g.year)) ? g.year : '', mName(g)].filter(Boolean).join(' ') }))
        : f === 'year' ? ICON.no + esc(fill(D.isKit ? T.skYear : T.skYearPart, { year: g.year }))
        : f === 'no' ? ICON.no + esc(fill(T.skNo, { model: mName(g) }))
        : f === 'check' ? ICON.q + esc(fill(T.skChk, { model: String(g.model || '').replace(/\s*\|\s*/g, ' / ') }))
        : ICON.q + esc(T.skNone);
      var price = curPrice();
      var cmp = variant && variant.compare > variant.price ? variant.compare : 0;
      var right = m.act === 'opt' ? fill(T.skChoose, { option: optPhrase(m.idx) }) : (D.onlyDefault ? '' : selected.filter(Boolean).join(' / '));
      stP.innerHTML = '<b>' + esc(price != null ? money(price, D.money) : D.priceLabel) + '</b>' + (cmp ? ' <s>' + esc(money(cmp, D.money)) + '</s>' : '') + (right ? ' · ' + esc(right) : '');
      stBtn.className = 'hauer-btn hauer-btn--red' + (m.cls === 'is-choose' ? ' is-choose' : m.cls === 'is-warn' ? ' is-warn' : '');
      stBtn.textContent = m.act === 'add' ? m.short : m.act === 'anyway' ? T.skSee : m.short;
    }
    function nudge(el) {
      if (!el) return;
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var sw = $('.hp-sw', el) || el;
      sw.classList.remove('is-nudge'); void sw.offsetWidth; sw.classList.add('is-nudge');
      var first = $('.hp-swb[tabindex="0"]', el) || $('.hp-swb', el);
      setTimeout(function () { focusNoScroll(first); }, 350);
    }
    function setQty(n) { state.qty = Math.max(1, Math.min(99, parseInt(n, 10) || 1)); if (qtyIn) qtyIn.value = state.qty; paintAll(); }
    $$('[data-hp-qty]').forEach(function (b) { b.addEventListener('click', function () { setQty(state.qty + (+b.dataset.hpQty)); }); });
    if (qtyIn) qtyIn.addEventListener('change', function () { setQty(qtyIn.value); });
    if (addBtn) addBtn.addEventListener('click', function (e) {
      var m = ctaModel();
      if (m.act === 'opt') { e.preventDefault(); nudge(optBoxes[m.idx]); return; }
      if (m.act === 'none') { e.preventDefault(); return; }
      if (m.act === 'anyway') {
        // "Add anyway · I checked it fits": a confirmação vale só para este envio e segue no pedido (A-13).
        // Não liga state.override: o painel continua mostrando o kit certo e o Shop Pay segue travado (24/09/2026).
        if (bikeProp) { bikeProp.value = fill(T.bikeOverride, { bike: bikeLabel(state.garage) }); bikeProp.disabled = false; }
        track('fit_override', { handle: D.handle, bike: bikeLabel(state.garage), source: 'add_anyway' });
      }
      track('add_to_cart_click', { handle: D.handle, variant: variant && variant.id, qty: state.qty, fit: state.override ? 'override' : state.fit });
    });
    if (stBtn) stBtn.addEventListener('click', function () {
      var m = ctaModel();
      if (m.act === 'opt') { nudge(optBoxes[m.idx]); return; }
      if (m.act === 'anyway') { fitBox.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      if (m.act === 'add' && form) { if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click(); }
    });
    // product-form.js limpa o aria-disabled depois do envio (sucesso ou erro): repinta quando ele solta o botão.
    ['on:cart:add', 'on:line-item:change', 'on:cart:error'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(function () { if (root.isConnected) paintAll(); }, 1500); });
    });
    // Barra fixa só quando o painel de encaixe e o botão principal estão fora da tela (e o rodapé também).
    (function () {
      if (!sticky || !('IntersectionObserver' in window)) return;
      var seen = { fit: true, buy: true, foot: false };
      var buy = $('[data-hp-buy]');
      var foot = document.querySelector('.shopify-section-group-footer-group, footer');
      function upd() {
        var on = !seen.fit && !seen.buy && !seen.foot && window.matchMedia('(max-width: 900px)').matches;
        sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        stBtn.tabIndex = on ? 0 : -1;
      }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { seen[e.target === fitBox ? 'fit' : e.target === foot ? 'foot' : 'buy'] = e.isIntersecting; });
        upd();
      }, { threshold: 0 });
      io.observe(fitBox); if (buy) io.observe(buy); if (foot) io.observe(foot);
      window.addEventListener('resize', upd);
    })();

    /* ================= Compare: coluna desta série + preço/link das outras ================= */
    (function () {
      var wrap = $('[data-hp-compare]'); if (!wrap) return;
      var table = $('table', wrap); if (!table || !table.rows.length) return;
      var head = table.rows[0];
      var series = String(D.series || '').toLowerCase();
      var here = -1, peersCol = {};
      Array.prototype.forEach.call(head.cells, function (c, i) {
        var t = String(c.textContent || '').trim().toLowerCase();
        if (series && t === series) here = i;
        (D.peers || []).forEach(function (p) { if (String(p.series).toLowerCase() === t) peersCol[i] = p; });
      });
      if (here < 0) return;
      Array.prototype.forEach.call(table.rows, function (r) { if (r.cells[here]) r.cells[here].classList.add('is-here'); });
      var hc = head.cells[here];
      hc.innerHTML = '<span class="hp-pill hp-pill--ok">' + esc(T.compareHere) + '</span>' + hc.innerHTML + (variant || D.priceLabel ? '<span class="p">' + esc(variant ? money(variant.price, D.money) : D.priceLabel) + '</span>' : '');
      var foot = '<tr>';
      var any = false;
      Array.prototype.forEach.call(head.cells, function (c, i) {
        if (i === here) foot += '<td class="is-here"><b>' + esc(T.compareThis) + '</b></td>';
        else if (peersCol[i]) { any = true; c.innerHTML += '<span class="p">' + esc(money(peersCol[i].price, D.money)) + '</span>'; foot += '<td><a href="' + esc(peersCol[i].url) + '">' + esc(fill(T.compareSee, { series: peersCol[i].series })) + '</a></td>'; }
        else foot += '<td></td>';
      });
      if (any) { var tf = table.createTFoot(); tf.innerHTML = foot + '</tr>'; }
    })();

    /* ================= Riders say (Judge.me) + nota da loja ================= */
    (function () {
      var box = $('[data-hp-riders]');
      var rateLink = $('[data-hp-store-rate]'), rateTxt = $('[data-hp-store-rate-txt]');
      var R = window.HauerReviews;
      if (!R || !D.reviewsDomain || typeof window.fetch !== 'function') return;
      var dlg = $('[data-hp-dlg]');
      var list = [];
      var bikeModel = String(D.bike || '').split(' ').slice(1).join(' ');
      var re = bikeModel ? R.bikeRe(bikeModel) : null;
      var partN = norm(D.part);
      var typeWord = norm(String(D.type || '').replace(/^(F1|S1|S)\s+/i, '').replace(/s$/i, ''));
      // Citação do card: até 60 caracteres, cortada no espaço (o card tem 3 linhas).
      function quote(r) {
        var q = String(R.firstLine(r) || '');
        if (q.length <= 60) return q;
        var cut = q.slice(0, 57), sp = cut.lastIndexOf(' ');
        return (sp > 30 ? cut.slice(0, sp) : cut).replace(/[\s,;:.-]+$/, '') + '\u2026';
      }
      function sameType(r) { return !!typeWord && norm(r.product).indexOf(typeWord) > -1; }
      function render(d) {
        var m = { rating: d.avg ? d.avg.toFixed(1) : '', count: d.total || '' };
        if (!D.productRating && rateLink && m.rating && m.count) { rateTxt.textContent = fill(T.rateStore, m); rateLink.hidden = false; }
        if (!box) return;
        var scoreEl = $('[data-hp-riders-score]', box);
        if (scoreEl && !D.productRating && m.rating) scoreEl.innerHTML = '<span class="hp-stars" aria-hidden="true">★</span> <b>' + esc(m.rating) + '</b> · ' + esc(fill(T.ridersStore, { count: m.count }));
        var seen = {};
        var scored = (d.reviews || []).filter(function (r) {
          if (!r.pics || !r.pics.length || r.score < 4 || String(R.firstLine(r) || '').length < 3) return false;
          var k = (r.author || '').toLowerCase(); if (k && seen[k]) return false; seen[k] = 1;
          return true;
        }).map(function (r, i) {
          var handle = String(r.url || '').split('?')[0].split('/products/').pop();
          var s = 0;
          if (handle === D.handle) s = 6;
          else {
            var bikeS = re ? R.score(r, re) : 0;
            if (norm(R.partName(r.product)) === partN) s += 2;
            s += bikeS;
            // Mesmo tipo de peça pesa mais que a moto (antes um amortecedor de GSX-S 1000 abria a página das manetes).
            if (typeWord) s += sameType(r) ? 3 : -1;
          }
          if (String(R.firstLine(r) || '').length <= 60) s += 0.3;
          return { r: r, s: s + (r.score === 5 ? 0.1 : 0), i: i };
        }).sort(function (a, b) { return (b.s - a.s) || (a.i - b.i); });
        var same = scored.filter(function (x) { return sameType(x.r); });
        if (same.length >= 2) scored = same;
        list = scored.slice(0, 3).map(function (x) { return x.r; });
        if (!list.length) return;
        $('[data-hp-rv]', box).innerHTML = list.map(function (r, i) {
          var part = R.partName(r.product);
          return '<li><button type="button" class="hp-rvc" data-rvi="' + i + '" aria-label="' + esc(fill(T.ridersOpen, { who: r.author || '' })) + '"><img class="hp-rvc__img" src="' + esc(R.sized(r.pics[0], 400)) + '" alt="" loading="lazy" width="400" height="400">' +
            '<span class="hp-rvc__stars" aria-label="' + r.score + ' / 5">' + R.stars(r.score) + '</span>' +
            '<span class="hp-rvc__q">“' + esc(quote(r)) + '”</span>' +
            '<span class="hp-rvc__who"><bdi>' + esc(r.author || 'Rider') + '</bdi>' + (part ? ' · ' + esc(part) : '') + '</span></button></li>';
        }).join('');
        $$('.hp-rvc__img', box).forEach(function (img) { img.addEventListener('error', function () { var li = img.closest('li'); if (li) li.remove(); if (!$('.hp-rvc', box)) box.hidden = true; }); });
        box.hidden = false;
      }
      if (box) box.addEventListener('click', function (e) {
        var b = e.target.closest('[data-rvi]'); if (!b || !dlg) return;
        var r = list[+b.dataset.rvi]; if (!r) return;
        var img = $('[data-hp-dlgimg]', dlg); img.src = R.sized(r.pics[0], 1024); img.alt = '';
        $('[data-hp-dlgstars]', dlg).textContent = R.stars(r.score);
        $('[data-hp-dlgh]', dlg).textContent = r.title || R.firstLine(r);
        $('[data-hp-dlgb]', dlg).textContent = r.text || '';
        $('[data-hp-dlgw]', dlg).textContent = [r.author || 'Rider', R.partName(r.product), R.fmtDate(r.date), r.verified ? T.verified : ''].filter(Boolean).join(' · ');
        var ln = $('[data-hp-dlglink]', dlg);
        if (ln) { ln.hidden = !r.url; if (r.url) { ln.href = r.url; ln.textContent = T.ridersPart + ' →'; } }
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        track('review_open', { handle: D.handle, review_product: r.product });
      });
      if (dlg) {
        var cl = $('[data-hp-dlgclose]', dlg);
        if (cl) cl.addEventListener('click', function () { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); });
        dlg.addEventListener('click', function (e) { if (e.target === dlg && dlg.close) dlg.close(); });
      }
      try { R.load(D.reviewsDomain, 4).then(render).catch(function () { /* Judge.me fora: a faixa fica escondida */ }); } catch (e) { /* noop */ }
    })();

    /* ================= Início ================= */
    state.firstGal = false;
    buildGallery(false);
    if (!D.onlyDefault && selected.some(function (v) { return v != null; })) { state.firstGal = true; resolveVariant(false); }
    paintFit();
  }

  function boot() { document.querySelectorAll('[data-hauer-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
